import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getMasterDataToken, postClientUrlWithToken, postDataWithoutResData } from "../Utils/restUtils";
import { getShareApi, Login, saveFcmToken, SignInUrl, verifySso } from "../CommonUrl";
import { SetUserName, setApiUrl, setSignInUrl, setUserRole, signIn, setCurrency, setPermissions, setSubscription, setIndustryId, setCompanyName, setRole, setSubscriptionDetails, setDecimal, setSubStatus, SetEmail, setCompanyId, setUserId, setDeviceToken, SetAdminUserId, setCountry } from '../Redux/Reducer';
import { useDispatch, useSelector } from "react-redux";
import * as authServices from "../Utils/authServices";
import Transparentspinner from "../Components/Common/Loader/Transparentspinner";
import { toast } from "react-toastify";
import { requestAndSaveFcmToken } from "../Firebase/SendFcmToken";

function LoginHandeler() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [searchParams] = useSearchParams();

    const authState = useSelector(state => state?.auth)

    const token = searchParams.get("token");
    const urlLogin = searchParams.get("login_url") || authState?.signInUrl;

    const autoSigIn = async () => {
        setLoading(true);
        const loginResponse = await postDataWithoutResData(verifySso, {
            token: token,
        });
        if (loginResponse?.data?.status === true) {
            setLoading(true);
            requestAndSaveFcmToken(loginResponse?.data?.data, dispatch);
            const { token, client_role, iso_code,client_role_id, url, company, company_user_id, company_name,user_id ,email, active_company, industry_type_id, master_subscription, package_name, package_expire_in, user_name, currency_symbol, permissions, master_token, decimal, login_url } = loginResponse.data.data;
            const packagetDetails = { packageName: package_name, packageExp: package_expire_in }
            authServices.setUser(token, client_role_id, master_token, master_subscription?.status);
            dispatch(setApiUrl(url));
            dispatch(setCompanyId(active_company));
            dispatch(setUserId(company_user_id));
            dispatch(SetAdminUserId(user_id));
            dispatch(signIn(company));
            dispatch(setCompanyName(company_name));
            dispatch(setIndustryId(industry_type_id));
            dispatch(setSubStatus(master_subscription))
            dispatch(setSubscription(master_subscription));
            dispatch(setSubscriptionDetails(packagetDetails));
            dispatch(setUserRole(client_role_id));
            dispatch(setRole(client_role));
            dispatch(SetUserName(user_name));
            dispatch(SetEmail(email));
            dispatch(setCurrency(currency_symbol));
            dispatch(setPermissions(permissions));
            dispatch(setDecimal(decimal));
            dispatch(setSignInUrl(login_url));
            dispatch(setCountry(iso_code));
            if (client_role_id === 1) {
                if (active_company === 0||active_company == null) {
                    navigate('/addCompany');
                } else if (master_subscription?.status === 'none' && master_subscription.company_type === 'multi') {
                    // navigate('/subscriptionAddition', { state: { id: active_company } });
                    navigate('/subscription', { state: { id: active_company } });
                } else if (master_subscription?.status === 'none' || (master_subscription?.status === 'Pending' && master_subscription?.plan_type === 'free')) {
                    navigate('/subscription', { state: { id: active_company } });
                } else if (master_subscription?.status === 'Pending' && master_subscription?.plan_type === 'paid') {
                    // let response = await getMasterDataToken(getShareApi + `?order_id=${master_subscription.invoice_id}`);
                    // if (response.status === true) {
                    //     const toReciept = `${process.env.PUBLIC_URL}/invoice?order_id=${response.data}`;
                    //     navigate(toReciept);
                    // }
                    // else {
                    //     HandleHomePageError(navigate, data.status)
                    // }
                    navigate('/subscription', { state: { id: active_company } });
                } else {
                    navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
                }
            } else if (loginResponse.data?.data?.status === "mobile_not_verified") {
                const mobileNumber = loginResponse.data.data.mobile;
                navigate('/SignUp', { state: { form: { updatedForm: { phone: mobileNumber } } } })
            } else {
                navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
            }
        }
        else {
            setLoading(false);
            toast.error(loginResponse?.response?.data?.message[0])
            window.location.href = urlLogin || SignInUrl
        }
        setLoading(false);

    }

    useEffect(() => {
        autoSigIn()
    }, [token]);

    if (loading) return <div><Transparentspinner /></div>;
    return null
}

export default LoginHandeler;
